export default "__VITE_ASSET__DlXZ3V8V__"